let _apiurl = process.env.VUE_APP_APIURL;
let _mode = process.env.VUE_APP_MODE;


export let apiurl = _apiurl;
export let mode = _mode;